import React from "react";
import { Routes, Route, Navigate } from "react-router-dom";
import { useAuth } from "./context/AuthContext";

// Layout
import Layout from "./components/Layout";

// Pages
import LoginPage from "./pages/LoginPage";
import DashboardPage from "./pages/DashboardPage";
import RsaListPage from "./pages/RsaListPage";
import DettaglioRsaPage from "./pages/DettaglioRsaPage";
import FornitoriListPage from "./pages/FornitoriListPage";
import DettaglioFornitorePage from "./pages/DettaglioFornitorePage";
import ContrattiListPage from "./pages/ContrattiListPage";
import ScadenzeListPage from "./pages/ScadenzeListPage";
import InterventiListPage from "./pages/InterventiListPage";
import NuovoInterventoPage from "./pages/NuovoInterventoPage";
import DettaglioInterventoPage from "./pages/DettaglioInterventoPage";
import RichiesteListPage from "./pages/RichiesteListPage";
import NuovaRichiestaPage from "./pages/NuovaRichiestaPage";
import RichiestaDetailPage from "./pages/RichiestaDetailPage";
import RichiestaRevisionePage from "./pages/RichiestaRevisionePage";
import MobileRichiestaPage from "./pages/MobileRichiestaPage";
import NuovoContrattoPage from "./pages/NuovoContrattoPage";
import DettaglioContrattoPage from "./pages/DettaglioContrattoPage";
import NuovaScadenzaPage from "./pages/NuovaScadenzaPage";
import DettaglioScadenzaPage from "./pages/DettaglioScadenzaPage";
import CalendarioPage from "./pages/CalendarioPage";
import DocumentiImmobiliPage from "./pages/DocumentiImmobiliPage";
import RapportiniPage from "./pages/RapportiniPage";
import ProfilePage from "./pages/ProfilePage";
import NotFoundPage from "./pages/NotFoundPage";
import NuovoImmobilePage from "./pages/NuovoImmobilePage";
import DettaglioImmobilePage from "./pages/DettaglioImmobilePage";
import NuovoAreaPage from "./pages/NuovoAreaPage";
import DettaglioAreaPage from "./pages/DettaglioAreaPage";
import ApparecchiatureListPage from "./pages/ApparecchiatureListPage";
import NuovaApparecchiaturaPage from "./pages/NuovaApparecchiaturaPage";
import DettaglioApparecchiaturaPage from "./pages/DettaglioApparecchiaturaPage";
import ImpiantiListPage from "./pages/ImpiantiListPage";
import NuovoImpiantoPage from "./pages/NuovoImpiantoPage";
import DettaglioImpiantoPage from "./pages/DettaglioImpiantoPage";
import ImportApparecchiaturePage from "./pages/ImportApparecchiaturePage";
import MappePage from "./pages/MappePage";
import ConsumiUtenzeListPage from "./pages/ConsumiUtenzeListPage";
import DettaglioConsumoPage from "./pages/DettaglioConsumoPage";
import NuovoConsumoPage from "./pages/NuovoConsumoPage";
import AnalisiConsumiPage from "./pages/AnalisiConsumiPage";
import ContatoriListPage from "./pages/ContatoriListPage";
import AzioniCorrettiveListPage from "./pages/AzioniCorrettiveListPage";
import DettaglioAzioneCorrettivaPage from "./pages/DettaglioAzioneCorrettivaPage";
import NuovaAzioneCorrettivaPage from "./pages/NuovaAzioneCorrettivaPage";

// Admin Pages
import AdminDashboardPage from "./pages/admin/AdminDashboardPage";
import RsaOnboardingPage from "./pages/admin/RsaOnboardingPage";
import FornitoreOnboardingPage from "./pages/admin/FornitoreOnboardingPage";
import TipologieFornituraPage from "./pages/admin/TipologieFornituraPage";
import TipologieInterventoPage from "./pages/admin/TipologieInterventoPage";
import GuideAutorisoluzionePage from "./pages/admin/GuideAutorisoluzionePage";
import AssociazioniPage from "./pages/admin/AssociazioniPage";
import DocumentiPage from "./pages/admin/DocumentiPage";
import NotifichePage from "./pages/admin/NotifichePage";
import InvioManualePage from "./pages/admin/InvioManualePage";
import UtentiPage from "./pages/admin/UtentiPage";
import ConfigurazioniPage from "./pages/admin/ConfigurazioniPage";
import EmailMappingPage from "./pages/admin/EmailMappingPage";
import IntegratoriApiPage from "./pages/admin/IntegratoriApiPage";
import CalendariAdminPage from "./pages/admin/CalendariAdminPage";
import TipiDocumentoPage from "./pages/admin/TipiDocumentoPage";
import MacrocategorieAdminPage from "./pages/admin/MacrocategorieAdminPage";
import PermessiRuoliPage from "./pages/admin/PermessiRuoliPage";
import PdfTemplatesPage from "./pages/admin/PdfTemplatesPage";
import ValutazioneFornitoriPage from "./pages/ValutazioneFornitoriPage";
import DettaglioValutazionePage from "./pages/DettaglioValutazionePage";
import CriteriValutazionePage from "./pages/admin/CriteriValutazionePage";
import ConfigDocumentiValutazionePage from "./pages/admin/ConfigDocumentiValutazionePage";
import EmailProcessingLogPage from "./pages/EmailProcessingLogPage";
import BollettaReviewPage from "./pages/BollettaReviewPage";
import SegnalazioniObbligatoriPage from "./pages/SegnalazioniObbligatoriPage";

// Protected Route wrapper (solo autenticazione)
function ProtectedRoute({ children }) {
  const { isAuthenticated, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="spinner w-12 h-12"></div>
      </div>
    );
  }

  if (!isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  return children;
}

// Error boundary to catch React render crashes
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }
  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }
  componentDidCatch(error, errorInfo) {
    console.error("ErrorBoundary caught:", error, errorInfo);
  }
  render() {
    if (this.state.hasError) {
      return (
        <div
          style={{
            padding: 20,
            background: "#fee2e2",
            borderRadius: 8,
            margin: 20,
          }}
        >
          <h2 style={{ color: "#b91c1c" }}>Errore di rendering</h2>
          <pre
            style={{ whiteSpace: "pre-wrap", fontSize: 12, color: "#7f1d1d" }}
          >
            {this.state.error?.message}
            {"\n"}
            {this.state.error?.stack}
          </pre>
          <button
            onClick={() => this.setState({ hasError: false, error: null })}
            style={{
              marginTop: 10,
              padding: "6px 12px",
              background: "#3b82f6",
              color: "white",
              border: "none",
              borderRadius: 4,
              cursor: "pointer",
            }}
          >
            Riprova
          </button>
        </div>
      );
    }
    return this.props.children;
  }
}

// Section-based route guard (permessi dinamici da Dataverse)
function SectionRoute({ children, section }) {
  const { canAccessSection } = useAuth();

  // Se nessuna sezione specificata, consenti a tutti gli autenticati
  if (!section) return children;

  if (!canAccessSection(section)) {
    return <Navigate to="/" replace />;
  }

  return children;
}

function App() {
  return (
    <Routes>
      {/* Public routes */}
      <Route path="/login" element={<LoginPage />} />
      <Route path="/m" element={<MobileRichiestaPage />} />

      {/* Protected routes */}
      <Route
        path="/"
        element={
          <ProtectedRoute>
            <Layout />
          </ProtectedRoute>
        }
      >
        <Route index element={<DashboardPage />} />
        <Route
          path="rsa"
          element={
            <SectionRoute section="rsa">
              <RsaListPage />
            </SectionRoute>
          }
        />
        <Route
          path="rsa/:id"
          element={
            <SectionRoute section="rsa">
              <DettaglioRsaPage />
            </SectionRoute>
          }
        />
        <Route
          path="immobili/nuovo"
          element={
            <SectionRoute section="rsa">
              <NuovoImmobilePage />
            </SectionRoute>
          }
        />
        <Route
          path="immobili/:id"
          element={
            <SectionRoute section="rsa">
              <DettaglioImmobilePage />
            </SectionRoute>
          }
        />
        <Route
          path="aree/nuovo"
          element={
            <SectionRoute section="rsa">
              <NuovoAreaPage />
            </SectionRoute>
          }
        />
        <Route
          path="aree/:id"
          element={
            <SectionRoute section="rsa">
              <DettaglioAreaPage />
            </SectionRoute>
          }
        />
        <Route
          path="apparecchiature"
          element={
            <SectionRoute section="apparecchiature">
              <ApparecchiatureListPage />
            </SectionRoute>
          }
        />
        <Route
          path="apparecchiature/import"
          element={
            <SectionRoute section="admin">
              <ImportApparecchiaturePage />
            </SectionRoute>
          }
        />
        <Route
          path="apparecchiature/nuovo"
          element={
            <SectionRoute section="apparecchiature">
              <NuovaApparecchiaturaPage />
            </SectionRoute>
          }
        />
        <Route
          path="apparecchiature/:id"
          element={
            <SectionRoute section="apparecchiature">
              <DettaglioApparecchiaturaPage />
            </SectionRoute>
          }
        />
        <Route
          path="apparecchiature/:id/modifica"
          element={
            <SectionRoute section="apparecchiature">
              <NuovaApparecchiaturaPage />
            </SectionRoute>
          }
        />
        <Route
          path="impianti"
          element={
            <SectionRoute section="impianti">
              <ImpiantiListPage />
            </SectionRoute>
          }
        />
        <Route
          path="impianti/nuovo"
          element={
            <SectionRoute section="impianti">
              <NuovoImpiantoPage />
            </SectionRoute>
          }
        />
        <Route
          path="impianti/:id"
          element={
            <SectionRoute section="impianti">
              <DettaglioImpiantoPage />
            </SectionRoute>
          }
        />
        <Route
          path="impianti/:id/modifica"
          element={
            <SectionRoute section="impianti">
              <NuovoImpiantoPage />
            </SectionRoute>
          }
        />
        <Route
          path="mappe"
          element={
            <SectionRoute section="mappe">
              <MappePage />
            </SectionRoute>
          }
        />
        <Route
          path="fornitori"
          element={
            <SectionRoute section="fornitori">
              <FornitoriListPage />
            </SectionRoute>
          }
        />
        <Route
          path="fornitori/:id"
          element={
            <SectionRoute section="fornitori">
              <DettaglioFornitorePage />
            </SectionRoute>
          }
        />
        <Route
          path="contratti"
          element={
            <SectionRoute section="contratti">
              <ContrattiListPage />
            </SectionRoute>
          }
        />
        <Route
          path="contratti/nuovo"
          element={
            <SectionRoute section="contratti">
              <NuovoContrattoPage />
            </SectionRoute>
          }
        />
        <Route
          path="contratti/:id"
          element={
            <SectionRoute section="contratti">
              <DettaglioContrattoPage />
            </SectionRoute>
          }
        />
        <Route
          path="contratti/:id/modifica"
          element={
            <SectionRoute section="contratti">
              <DettaglioContrattoPage />
            </SectionRoute>
          }
        />
        <Route
          path="scadenze"
          element={
            <SectionRoute section="scadenze">
              <ScadenzeListPage />
            </SectionRoute>
          }
        />
        <Route
          path="scadenze/nuova"
          element={
            <SectionRoute section="scadenze">
              <NuovaScadenzaPage />
            </SectionRoute>
          }
        />
        <Route
          path="scadenze/:id"
          element={
            <SectionRoute section="scadenze">
              <DettaglioScadenzaPage />
            </SectionRoute>
          }
        />
        <Route
          path="calendario"
          element={
            <SectionRoute section="calendario">
              <CalendarioPage />
            </SectionRoute>
          }
        />
        <Route
          path="interventi"
          element={
            <SectionRoute section="interventi">
              <InterventiListPage />
            </SectionRoute>
          }
        />
        <Route
          path="interventi/nuovo"
          element={
            <SectionRoute section="interventi">
              <NuovoInterventoPage />
            </SectionRoute>
          }
        />
        <Route
          path="interventi/:id"
          element={
            <SectionRoute section="interventi">
              <DettaglioInterventoPage />
            </SectionRoute>
          }
        />
        {/* Richieste Intervento Routes */}
        <Route
          path="richieste-intervento"
          element={
            <SectionRoute section="richieste_intervento">
              <RichiesteListPage />
            </SectionRoute>
          }
        />
        <Route
          path="richieste-intervento/nuova"
          element={
            <SectionRoute section="richieste_intervento">
              <NuovaRichiestaPage />
            </SectionRoute>
          }
        />
        <Route
          path="richieste-intervento/:id"
          element={
            <SectionRoute section="richieste_intervento">
              <RichiestaDetailPage />
            </SectionRoute>
          }
        />
        <Route
          path="richieste-intervento/:id/revisione"
          element={
            <SectionRoute section="richieste_intervento">
              <RichiestaRevisionePage />
            </SectionRoute>
          }
        />
        {/* Azioni Correttive Routes */}
        <Route
          path="azioni-correttive"
          element={
            <SectionRoute section="azioni_correttive">
              <AzioniCorrettiveListPage />
            </SectionRoute>
          }
        />
        <Route
          path="azioni-correttive/nuovo"
          element={
            <SectionRoute section="azioni_correttive">
              <NuovaAzioneCorrettivaPage />
            </SectionRoute>
          }
        />
        <Route
          path="azioni-correttive/:id"
          element={
            <SectionRoute section="azioni_correttive">
              <DettaglioAzioneCorrettivaPage />
            </SectionRoute>
          }
        />

        {/* Valutazione Fornitori Routes */}
        <Route
          path="valutazione-fornitori"
          element={
            <SectionRoute section="valutazione_fornitori">
              <ValutazioneFornitoriPage />
            </SectionRoute>
          }
        />
        <Route
          path="valutazione-fornitori/:id"
          element={
            <SectionRoute section="valutazione_fornitori">
              <DettaglioValutazionePage />
            </SectionRoute>
          }
        />
        <Route
          path="email-processing"
          element={
            <SectionRoute section="email_processing">
              <EmailProcessingLogPage />
            </SectionRoute>
          }
        />
        <Route
          path="bollette-review"
          element={
            <SectionRoute section="bollette_review">
              <BollettaReviewPage />
            </SectionRoute>
          }
        />

        <Route
          path="rapportini"
          element={
            <SectionRoute section="rapportini">
              <RapportiniPage />
            </SectionRoute>
          }
        />
        <Route
          path="documenti-immobili"
          element={
            <SectionRoute section="documenti_immobili">
              <DocumentiImmobiliPage />
            </SectionRoute>
          }
        />
        {/* Consumi Utenze Routes */}
        <Route
          path="consumi-utenze"
          element={
            <SectionRoute section="consumi_utenze">
              <ConsumiUtenzeListPage />
            </SectionRoute>
          }
        />
        <Route
          path="consumi-utenze/nuovo"
          element={
            <SectionRoute section="consumi_utenze">
              <NuovoConsumoPage />
            </SectionRoute>
          }
        />
        <Route
          path="consumi-utenze/:id"
          element={
            <SectionRoute section="consumi_utenze">
              <DettaglioConsumoPage />
            </SectionRoute>
          }
        />
        <Route
          path="consumi-utenze/:id/modifica"
          element={
            <SectionRoute section="consumi_utenze">
              <NuovoConsumoPage />
            </SectionRoute>
          }
        />
        <Route
          path="consumi-utenze/analisi"
          element={
            <SectionRoute section="consumi_utenze">
              <AnalisiConsumiPage />
            </SectionRoute>
          }
        />
        <Route
          path="contatori"
          element={
            <SectionRoute section="consumi_utenze">
              <ContatoriListPage />
            </SectionRoute>
          }
        />

        <Route path="profilo" element={<ProfilePage />} />

        {/* Admin Routes */}
        <Route
          path="admin"
          element={
            <SectionRoute section="admin">
              <AdminDashboardPage />
            </SectionRoute>
          }
        />
        <Route
          path="admin/rsa/nuovo"
          element={
            <SectionRoute section="admin">
              <RsaOnboardingPage />
            </SectionRoute>
          }
        />
        <Route
          path="admin/fornitori/nuovo"
          element={
            <SectionRoute section="admin">
              <FornitoreOnboardingPage />
            </SectionRoute>
          }
        />
        <Route
          path="admin/utenti"
          element={
            <SectionRoute section="admin">
              <UtentiPage />
            </SectionRoute>
          }
        />
        <Route
          path="admin/utenti/nuovo"
          element={
            <SectionRoute section="admin">
              <UtentiPage />
            </SectionRoute>
          }
        />
        <Route
          path="admin/tipologie-fornitura"
          element={
            <SectionRoute section="admin">
              <TipologieFornituraPage />
            </SectionRoute>
          }
        />
        <Route
          path="admin/tipologie-intervento"
          element={
            <SectionRoute section="admin">
              <TipologieInterventoPage />
            </SectionRoute>
          }
        />
        <Route
          path="admin/guide-autorisoluzione"
          element={
            <SectionRoute section="admin">
              <GuideAutorisoluzionePage />
            </SectionRoute>
          }
        />
        <Route
          path="admin/criteri-valutazione"
          element={
            <SectionRoute section="admin">
              <CriteriValutazionePage />
            </SectionRoute>
          }
        />
        <Route
          path="admin/config-documenti-valutazione"
          element={
            <SectionRoute section="admin">
              <ConfigDocumentiValutazionePage />
            </SectionRoute>
          }
        />
        <Route
          path="admin/tipi-documento"
          element={
            <SectionRoute section="admin">
              <TipiDocumentoPage />
            </SectionRoute>
          }
        />
        <Route
          path="admin/macrocategorie"
          element={
            <SectionRoute section="admin">
              <MacrocategorieAdminPage />
            </SectionRoute>
          }
        />
        <Route
          path="admin/associazioni/fornitore-rsa"
          element={
            <SectionRoute section="admin">
              <AssociazioniPage />
            </SectionRoute>
          }
        />
        <Route
          path="admin/associazioni/fornitore-tipologie"
          element={
            <SectionRoute section="admin">
              <AssociazioniPage />
            </SectionRoute>
          }
        />
        <Route
          path="admin/contratti/nuovo"
          element={
            <SectionRoute section="admin">
              <NuovoContrattoPage />
            </SectionRoute>
          }
        />
        <Route
          path="admin/documenti"
          element={
            <SectionRoute section="admin">
              <DocumentiPage />
            </SectionRoute>
          }
        />
        <Route
          path="admin/documenti/upload"
          element={
            <SectionRoute section="admin">
              <DocumentiPage />
            </SectionRoute>
          }
        />
        <Route
          path="admin/permessi-ruoli"
          element={
            <SectionRoute section="admin">
              <PermessiRuoliPage />
            </SectionRoute>
          }
        />

        {/* Notifiche Routes */}
        <Route
          path="admin/notifiche"
          element={
            <SectionRoute section="admin">
              <NotifichePage />
            </SectionRoute>
          }
        />
        <Route
          path="admin/notifiche/invia"
          element={
            <SectionRoute section="admin">
              <InvioManualePage />
            </SectionRoute>
          }
        />
        <Route
          path="admin/notifiche/invio"
          element={
            <SectionRoute section="admin">
              <InvioManualePage />
            </SectionRoute>
          }
        />
        <Route
          path="admin/notifiche/configurazione"
          element={
            <SectionRoute section="admin">
              <NotifichePage />
            </SectionRoute>
          }
        />
        <Route
          path="admin/notifiche/storico"
          element={
            <SectionRoute section="admin">
              <NotifichePage />
            </SectionRoute>
          }
        />

        {/* Configurazioni Sistema */}
        <Route
          path="admin/configurazioni"
          element={
            <SectionRoute section="admin">
              <ConfigurazioniPage />
            </SectionRoute>
          }
        />

        {/* Email Mapping */}
        <Route
          path="admin/email-mapping"
          element={
            <SectionRoute section="admin">
              <EmailMappingPage />
            </SectionRoute>
          }
        />

        {/* Integratori API (sistemi terzi multi-fornitore) */}
        <Route
          path="admin/integratori-api"
          element={
            <SectionRoute section="admin">
              <IntegratoriApiPage />
            </SectionRoute>
          }
        />

        {/* Calendari Admin */}
        <Route
          path="admin/calendari"
          element={
            <SectionRoute section="admin">
              <CalendariAdminPage />
            </SectionRoute>
          }
        />

        {/* PDF Templates Admin */}
        <Route
          path="admin/pdf-templates"
          element={
            <SectionRoute section="admin">
              <PdfTemplatesPage />
            </SectionRoute>
          }
        />

        {/* Segnalazioni Obbligatori */}
        <Route
          path="segnalazioni-obbligatori"
          element={
            <SectionRoute section="segnalazioni_obbligatori">
              <SegnalazioniObbligatoriPage />
            </SectionRoute>
          }
        />
      </Route>

      {/* 404 */}
      <Route path="*" element={<NotFoundPage />} />
    </Routes>
  );
}

export default App;
